module.exports = __webpack_public_path__ + "static/tm-d55963e2cb1d6f0a57229b106de17db8.svg";